import { format, formatMessage } from "lib/globalize-util";
import React, { MouseEvent } from "react";
import "./delete-target-dialog.css";
import { AlertIcon } from "./alert-icon";
import { CrossIcon } from "./cross-icon";

interface Props {
    isDialogOpen: boolean;
    closeDialog: () => void;
    targetName: string;
    onConfirm: () => void;
}

export const DeleteTargetDialog = ({ closeDialog, onConfirm, targetName, isDialogOpen }: Props) => {
    const ref = React.useRef<HTMLDialogElement>(null);

    React.useEffect(() => {
        if (isDialogOpen) {
            ref.current?.showModal();
            document.body.classList.add("modal-open"); // prevent bg scroll
        } else {
            ref.current?.close();
            document.body.classList.remove("modal-open");
        }
    }, [isDialogOpen]);

    return (
        <dialog
            id="delete-target-dialog"
            className="delete-target-dialog"
            ref={ref}
            onClick={(e) => ref.current && !isClickInsideRectangle(e, ref.current) && closeDialog()}
        >
            <div className="delete-target-dialog-title-wrapper">
                <div className="delete-target-dialog-title">
                    <AlertIcon />
                    <div>{formatMessage("Delete target")}?</div>
                </div>
                <button onClick={closeDialog} className="delete-target-dialog-cross-button">
                    <CrossIcon />
                </button>
            </div>
            <div className="delete-target-dialog-divider" />
            <div className="delete-target-dialog-body">
                {format("Deleting |targetName| is permanent and can't be undone.", { targetName })}
            </div>
            <div className="delete-target-dialog-footer">
                <button
                    onClick={closeDialog}
                    className="delete-target-dialog-button delete-target-dialog-button-secondary"
                >
                    {formatMessage("Cancel")}
                </button>
                <button onClick={onConfirm} className="delete-target-dialog-button delete-target-dialog-button-danger">
                    {formatMessage("Delete")}
                </button>
            </div>
        </dialog>
    );
};

const isClickInsideRectangle = (e: MouseEvent, element: HTMLElement) => {
    const r = element.getBoundingClientRect();

    return e.clientX > r.left && e.clientX < r.right && e.clientY > r.top && e.clientY < r.bottom;
};
